import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IAppointmentData } from 'src/app/models/IAppointmentDetails';
import { IReportParameters } from 'src/app/models/IReportParameters';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { ShowSSRSReportComponent } from '../show-ssrsreport/show-ssrsreport.component';
import { configuration } from 'src/environments/environment';
import { FollowupNewAppointmentComponent } from '../followup-new-appointment/followup-new-appointment.component';
import { ConfirmDialogModel } from 'src/app/PatientChart/Document/delete-document/delete-document.component';
import { FollowupSurgeryReferralComponent } from '../followup-surgery-referral/followup-surgery-referral.component';
import { SharedService } from 'src/app/Sharedservice/SharedService';


@Component({
  selector: 'app-next-appointment',
  templateUrl: './next-appointment.component.html',
  styleUrls: ['./next-appointment.component.css']
})

export class NextAppointmentComponent implements OnInit {
  displayedColumns: string[] = ['appttime', 'visitdate', 'visittype', 'provider', 'location',];
  futureAppointments: IAppointmentData[] = [];
  navigationPage: any;
  constructor(
    public dialogRef: MatDialogRef<NextAppointmentComponent>, private bannerService: PatientBannerService,
    @Inject(MAT_DIALOG_DATA) public data: IAppointmentData, private schedulerService: SchedularServiceService, private router: Router, private crypto: AESAlgorithm
    , public dialog: MatDialog, private toastr: ToastrService, private sharedservice: SharedService) {
    this.navigationPage = data.description;

  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  ngOnInit() {
    this.getNextAppointments();
  }

  getNextAppointments() {
    this.schedulerService.getPatientFutureAppointments(this.data.patientId, 0, this.data.Id)
      .subscribe(
        (result: any) => {
          this.futureAppointments = result;
          if (this.futureAppointments == null || this.futureAppointments.length == 0) {
            if (this.data != null && this.data != undefined) {
              CommonComponents.patientId = this.data.patientId;
              CommonComponents.patientName = this.data.name;
              this.bannerService.toggle(this.data.patientId);
              sessionStorage.setItem("patientId", this.data.patientId.toString());
              sessionStorage.setItem("patientName", this.data.name);
              if ((sessionStorage.getItem("displayappDate") != null || sessionStorage.getItem("displayappDate") != undefined) && sessionStorage.getItem("displayappDate") != "null") {
                var displayDate = sessionStorage.getItem("displayappDate");
                sessionStorage.setItem("displayDate", displayDate);
              }
              sessionStorage.setItem("displayappDate", null);
              sessionStorage.setItem("displayappDate1", null);
              if (this.navigationPage == 'FOLLOWUP') {
                this.router.navigateByUrl('/NewAppointment?providerId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.data.physician))
                  + '&locationId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(Number(this.data.locationId)))
                  + '&&fromFollowup=true');
              }
              else {
                this.router.navigateByUrl('/NewAppointment?providerId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.data.physician))
                  + '&locationId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(Number(this.data.locationId)))
                );
              }
              this.dialogRef.close();
            }
          }

        });
  }
  selectedRow: IAppointmentData;

  oncellclick(row: any) {
    this.selectedRow = row;
    if (this.selectedRow.visitNoteStatus == 'In Progress') {
      this.toastr.warning("Cannot reschedule/update '" + this.selectedRow.status + "' Appointment");
    } else {
      CommonComponents.patientId = row.patientId;
      CommonComponents.patientName = row.name;
      this.bannerService.toggle(row.patientId);
      sessionStorage.setItem("patientId", row.patientId.toString());
      sessionStorage.setItem("patientName", row.name);
      sessionStorage.setItem("appDate", row.start);
      if ((sessionStorage.getItem("displayappDate") != null || sessionStorage.getItem("displayappDate") != undefined) && sessionStorage.getItem("displayappDate") != "null") {
        var displayDate = sessionStorage.getItem("displayappDate");
        sessionStorage.setItem("displayDate", displayDate);
      }
      sessionStorage.setItem("displayappDate", null);
      sessionStorage.setItem("displayappDate1", null);
      if (this.navigationPage != 'FOLLOWUP')
        this.router.navigateByUrl('/NewAppointment?id=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.selectedRow.Id)));
      else
        this.router.navigateByUrl('/NewAppointment?id=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.selectedRow.Id))
          + '&&fromFollowup=true');

      this.dialogRef.close();
    }
  }

  newAppointment() {
    var isParentFacility = sessionStorage.getItem("isParentFacility");
    if (isParentFacility == "1") {
      this.dialogRef.close(true);
      const message = "Where would you like to schedule the patient's next appointment?";
      const dialogData = new ConfirmDialogModel('Schedule Follow-up Appointment', message);
      const dialogRef = this.dialog.open(FollowupNewAppointmentComponent, {
        width: '32%',
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(type => {
        if (type == 'C') {
          if (this.data != null && this.data != undefined) {
            CommonComponents.patientId = this.data.patientId;
            CommonComponents.patientName = this.data.name;
            this.bannerService.toggle(this.data.patientId);
            sessionStorage.setItem("patientId", this.data.patientId.toString());
            sessionStorage.setItem("patientName", this.data.name);
            if ((sessionStorage.getItem("displayappDate") != null || sessionStorage.getItem("displayappDate") != undefined) && sessionStorage.getItem("displayappDate") != "null") {
              var displayDate = sessionStorage.getItem("displayappDate");
              sessionStorage.setItem("displayDate", displayDate);
            }
            if ((sessionStorage.getItem("displayappDate1") != null || sessionStorage.getItem("displayappDate1") != undefined) && sessionStorage.getItem("displayappDate1") != "null") {
              var displayDate = sessionStorage.getItem("displayappDate1");
              sessionStorage.setItem("displayDate", displayDate);
            }
            sessionStorage.setItem("displayappDate", null);
            sessionStorage.setItem("displayappDate1", null);
            if (this.navigationPage != 'FOLLOWUP') {
              this.router.navigateByUrl('/NewAppointment?providerId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.data.physician))
                + '&locationId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(Number(this.data.locationId))));
            }
            else {
              this.router.navigateByUrl('/NewAppointment?providerId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.data.physician))
                + '&locationId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(Number(this.data.locationId))) + '&&fromFollowup=true');
            }
            this.dialogRef.close(true);
          }
        } else if (type == 'S') {
          const dialogData = new ConfirmDialogModel('Create Surgery Center Referral', "", this.data.patientId);
          const dialogRef = this.dialog.open(FollowupSurgeryReferralComponent, {
            maxWidth: '40%',
            data: dialogData
          });
          dialogRef.afterClosed().subscribe(saveParam => {
            if (saveParam != null && saveParam != undefined)
              this.sharedservice.InsertPatientInfoInASCFacility(saveParam).subscribe((data) => { this.toastr.success(data);});
          });
        }
      });
    } else {
      if (this.data != null && this.data != undefined) {
        CommonComponents.patientId = this.data.patientId;
        CommonComponents.patientName = this.data.name;
        this.bannerService.toggle(this.data.patientId);
        sessionStorage.setItem("patientId", this.data.patientId.toString());
        sessionStorage.setItem("patientName", this.data.name);
        if ((sessionStorage.getItem("displayappDate") != null || sessionStorage.getItem("displayappDate") != undefined) && sessionStorage.getItem("displayappDate") != "null") {
          var displayDate = sessionStorage.getItem("displayappDate");
          sessionStorage.setItem("displayDate", displayDate);
        }
        if ((sessionStorage.getItem("displayappDate1") != null || sessionStorage.getItem("displayappDate1") != undefined) && sessionStorage.getItem("displayappDate1") != "null") {
          var displayDate = sessionStorage.getItem("displayappDate1");
          sessionStorage.setItem("displayDate", displayDate);
        }
        sessionStorage.setItem("displayappDate", null);
        sessionStorage.setItem("displayappDate1", null);
        if (this.navigationPage != 'FOLLOWUP') {
          this.router.navigateByUrl('/NewAppointment?providerId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.data.physician))
            + '&locationId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(Number(this.data.locationId))));
        }
        else {
          this.router.navigateByUrl('/NewAppointment?providerId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(this.data.physician))
            + '&locationId=' + encodeURIComponent(this.crypto.urlParmeterEncoder(Number(this.data.locationId))) + '&&fromFollowup=true');
        }
        this.dialogRef.close(true);
      }
    }
  }



  reportParamters: IReportParameters;
  futureAppointmentpreview(): void {

    this.reportParamters = new IReportParameters();
    //NEW
    this.schedulerService.getPatientFutureAppointmentsCount(this.data.patientId, this.data.locationId, this.data.Id)
      .subscribe(
        (result: any) => {
          if (result !== 0 && result !== undefined && result !== null) {
            this.reportParamters.reportUrl = configuration.reportsUrl + "/FutureAppointmentRpt";//'NEMR/FutureAppointments';
            this.reportParamters.parameters = {
              "appId": this.data.Id,
              "locationId": this.data.locationId,
              "patId": this.data.patientId,
            };
            const dialogRef = this.dialog.open(ShowSSRSReportComponent, {
              width: '850px',
              height: '100%',
              data: this.reportParamters
            });

            dialogRef.afterClosed().subscribe(result => {
            });
          } else {
            this.toastr.warning('No Future Appointments');
          }
        });
  }
}

